
import request from '../../Helpers/Request';

class Payments {
    constructor(settings) {
        this.settings = settings;
    }

    index(params) {
        return new Promise((resolve, reject) => {
            request('GET', '/admin/payments', this.settings, null, true, params)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    show(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/admin/payments/${id}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    exportSepa(params) {
        return new Promise((resolve, reject) => {
            request('GET', '/admin/payments/export/sepa', this.settings, null, true, params)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    exportCsv(params) {
        return new Promise((resolve, reject) => {
            request('GET', '/admin/payments/export/csv', this.settings, null, true, params)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    unmarkAsExported(id) {
        return new Promise((resolve, reject) => {
            request('PATCH', `/admin/payments/${id}/export/unmark`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default Payments;
